export enum PRODUCT_SEGMENT {
  CORE = 'core',
  VC = 'vc',
  EXTEND_RUNWAY = 'extend_runway',
  MRR_FACTORING = 'mrr_factoring',
  INSIGHTS = 'insights',
  INDIEGOGO = 'indiegogo',
  BETA = 'beta',
  BNPL = 'bnpl',
}
